import { useLocation } from 'react-router-dom';
import LogoPasteur from '../../../assets/img/LogoNuevo.png';
import Container from 'react-bootstrap/Container';
import { RootState } from '../../../store/config/types';
import { connect, ConnectedProps } from 'react-redux';

const mapStateToProps = (state: RootState) => ({
  subscriptionTypes: state.subscriptionTypes,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

function Header({ subscriptionTypes }: PropsFromRedux) {
  const location = useLocation();
  const isResultPage = location.pathname === '/result';

  return (
    <div className={`header ${isResultPage ? 'header-no-info' : 'header-info'}`}>
      <Container>
        <div className="logo">
          <img src={LogoPasteur} alt="Logo Pasteur" />
        </div>
      </Container>
    </div>
  );
}

export default connector(Header);
